const defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
export const legacyGinIssueEditRoute = {
	name: 'legacy-gin-issue-edit',
	path: `/secure/EditIssue${defaultSuffix}.jspaa`,
};
